import { Alert, AlertTitle, Button } from '@mui/material';

import { StatePanel } from './StatePanel';

export type ErrorStateProps = {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryName?: string;
};

export const ErrorState = ({ title = 'Something went wrong', message, onRetry, retryName = 'Retry' }: ErrorStateProps) => (
  <StatePanel testId="error-state">
    <Alert
      severity="error"
      sx={{ width: '100%' }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry} aria-label={retryName}>
            Retry
          </Button>
        ) : undefined
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  </StatePanel>
);
